import { Link } from 'react-router-dom';
import { siteConfig, categories } from '@/mocks/site';

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-900 text-background-100 mt-20">
      <div className="px-4 md:px-10 pt-14 md:pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2.5 cursor-pointer">
              <span className="w-10 h-10 rounded-md bg-accent-500 text-primary-950 flex items-center justify-center font-heading text-xl font-black">
                黑
              </span>
              <span className="font-heading text-2xl font-black text-background-50">
                {siteConfig.name}
              </span>
            </Link>
            <p className="mt-5 text-sm leading-relaxed text-primary-200/90">
              {siteConfig.positioning}，让每一次「找话题」都变成「刷合集」。精选盘点与分类榜单持续更新。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {['ri-wechat-line', 'ri-weibo-line', 'ri-mail-line', 'ri-rss-line'].map((icon) => (
                <span
                  key={icon}
                  className="w-9 h-9 rounded-md border border-primary-700 text-primary-100 flex items-center justify-center text-base"
                >
                  <i className={icon}></i>
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-5">站内导航</h4>
            <ul className="space-y-3 text-sm">
              {[
                { label: '首页', path: '/' },
                { label: '专题合集总览', path: '/topics' },
                { label: '榜单盘点', path: '/rankings' },
                { label: '关于我们', path: '/about' },
              ].map((item) => (
                <li key={item.path}>
                  <Link to={item.path} className="text-primary-200/90 hover:text-accent-400 transition-colors cursor-pointer">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-5">专题分类</h4>
            <ul className="space-y-3 text-sm">
              {categories.slice(1).map((cat) => (
                <li key={cat.key}>
                  <Link
                    to={`/topics?cat=${cat.key}`}
                    className="text-primary-200/90 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-5">联系与投稿</h4>
            <ul className="space-y-3 text-sm text-primary-200/90">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-1 text-accent-400"></i>
                <span className="whitespace-nowrap">{siteConfig.email}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-hand-heart-line mt-1 text-accent-400"></i>
                <span className="whitespace-nowrap">{siteConfig.cooperateEmail}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line mt-1 text-accent-400"></i>
                <span>专题每天 09:00 与 20:00 更新</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-primary-700/70 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-primary-300/80">
          <p>© {year} {siteConfig.name} · 专题合集与精选盘点内容门户</p>
          <p className="flex items-center gap-4">
            <span>站内专题结构为原创编排</span>
            <span className="hidden sm:inline">·</span>
            <Link to="/about" className="hover:text-accent-400 transition-colors cursor-pointer">
              内容原则
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
}